import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import SearchContext from '../../../context/search-context';
import styles from './RepresentativeSearchResultTable.module.css';
import Customer from '../../../models/Customer';

type RepresentativeSearchResultTableProps = {
  onSelect: (customers: Customer[]) => void
}

function RepresentativeSearchResultTable(props: RepresentativeSearchResultTableProps) {
  const { t } = useTranslation();
  const navigation = useNavigate();
  const searchCtx = useContext(SearchContext);
  const [selectedRepresentative, setSelectedRepresentative] = useState<Customer[]>([]);

  const addRepresentative = (representative: Customer) => {
    setSelectedRepresentative(prevState => prevState.concat(representative));
  };

  const removeRepresentative = (representativeId: number) => {
    setSelectedRepresentative(prevState => prevState.filter(
      customer => customer.id !== representativeId,
    ));
  };

  const handleAdd = () => {
    props.onSelect(selectedRepresentative);
  };

  const handleCancel = () => {
    navigation('/customer');
  };

  return (
    <div className={styles.container}>
      <p>{t('header.search.searchResult', { numberOfCustomers: searchCtx.searchResult.length })}</p>
      {searchCtx.showNotification &&
        <p className={styles.notification}>{t('header.search.tooManyClients')}</p>}
      {searchCtx.searchResult.length > 0 && (
        <table className={styles.table}>
          <thead>
          <tr className={styles.row}>
            <th>&nbsp;</th>
            <th>{t('header.search.tableHeadings.client')}</th>
            <th>{t('header.search.tableHeadings.id')}</th>
            <th>{t('header.search.tableHeadings.cif')}</th>
            <th>{t('header.search.tableHeadings.login')}</th>
          </tr>
          </thead>
          <tbody>
          {searchCtx.searchResult.map(representative =>
            <tr className={classNames(
              styles.row,
              selectedRepresentative.includes(representative) && styles.selected,
            )} key={representative.id}>
              <td>
                <input
                  type='checkbox'
                  onChange={(event) => event.target.checked
                    ? addRepresentative(representative)
                    : removeRepresentative(representative.id!)
                  } />
              </td>
              <td>
                {representative.firstName}
                {' '}
                {representative.name}
              </td>
              <td>{representative.registrationCode}</td>
              <td>{representative.cif}</td>
              <td>{representative.loginName}</td>
            </tr>,
          )}
          </tbody>
        </table>
      )}
      <div className={styles.buttonsContainer}>
        <div
          role='button'
          tabIndex={0}
          onClick={handleAdd}
          onKeyDown={handleAdd}
          className={classNames(styles.button, styles.addButton)}
        >
          {t('common.add')}
        </div>
        <div
          role='button'
          tabIndex={0}
          onClick={handleCancel}
          onKeyDown={handleCancel}
          className={styles.button}
        >
          {t('common.cancel')}
        </div>
      </div>
    </div>
  );
}

export default RepresentativeSearchResultTable;
